import {AppState} from '../store';
import {kilogramFormatter} from '../../utils/numberFormatter';
import {format} from 'date-fns';

export const getGoldReserve = (state: AppState) => state.goldReserve;

export const getGoldReserveData = (state: AppState) => state.goldReserve.data;

export const getGoldReserveIsSaving = (state: AppState) =>
  state.goldReserve.isSaving;

export const getGoldReserveIsLoading = (state: AppState) =>
  state.goldReserve.isLoading;

export const getGoldReserveLatest = (state: AppState) =>
  state.goldReserve.latest || {
    amount: 0,
    timestamp: new Date().toString,
    actor: '',
    id: 0,
  };

export const getGoldReserveMeta = (state: AppState) =>
  state.goldReserve.data?.meta || {
    totalItems: 0,
    itemCount: 0,
    itemsPerPage: 0,
    totalPages: 0,
    currentPage: 0,
  };

export const getGoldReserveItems = (state: AppState) =>
  state.goldReserve.data?.items || [];

export const getGoldReserveHistoryTable = (
  state: AppState,
): [{value: string}, {value: string}, {value: string}][] =>
  getGoldReserveItems(state).map(({amount, actor, timestamp}) => [
    {value: kilogramFormatter(amount)},
    {value: actor},
    {value: format(new Date(timestamp), 'H:mm  d MMMM yyyy')},
  ]);
